import ApiService from './ApiService';

class PostService {
  // Erstelle einen neuen Event (Upload + Erstellung in zwei Schritten)
  async createPost(postData) {
    try {
      console.log('🔍 DEBUG: Erhaltene postData:', postData);

      // Plattformen bestimmen
      let platforms = postData.platforms || [];
      if (!postData.platforms || postData.platforms.length === 0) {
        platforms = [];
        if (postData.instagram) platforms.push('instagram');
        if (postData.homepage) platforms.push('homepage');
      }

      // Hintergrundbild-Pfad konvertieren (z.B. "gelb-10" → "gelb/10")
      let backgroundImagePath = '';
      if (postData.backgroundImage) {
        const parts = postData.backgroundImage.split('-');
        if (parts.length >= 2) {
          const color = parts[0];
          const variant = parts.slice(1).join('-');
          backgroundImagePath = `${color}/${variant}`;
        } else {
          backgroundImagePath = postData.backgroundImage;
        }
      }

      // SCHRITT 1: Bilder hochladen (falls vorhanden)
      let imagePaths = [];
      const files = postData.images || [];
      if (files.length > 0) {
        const uploadForm = new FormData();
        files.forEach(file => uploadForm.append('files', file));

        console.log('📤 SCHRITT 1: POST /upload –', files.length, 'Bild(er) hochladen...');
        const uploadResult = await ApiService.postFormData('/upload', uploadForm);
        console.log('✅ Upload Response:', uploadResult);

        // Pfade extrahieren – Backend gibt { files: [{ path: "..." }] } zurück
        imagePaths = (uploadResult.files || []).map(f => f.path ?? f);
        console.log('📋 Extrahierte Pfade:', imagePaths);
      } else {
        console.warn('⚠️ Keine Dateien zum Hochladen vorhanden');
      }

      // SCHRITT 2: Event per JSON erstellen
      const requestBody = {
        platforms,
        title: postData.title || '',
        date: postData.date || postData.datum || '',
        location: postData.location || '',
        leaders: parseInt(postData.leaders || postData.leiter) || 0,
        children: parseInt(postData.children || postData.kinder) || 0,
        description: postData.overlayText || postData.contentInstagram || '',
        instagramDescription: postData.description || '',
        homepageDescription: postData.homepageDescription || postData.contentHomepage || '',
        backgroundImage: backgroundImagePath,
        ersteller: postData.ersteller || '',
        images: imagePaths,
      };
      if (postData.featuredImage) requestBody.featuredImage = postData.featuredImage;

      console.log('📤 SCHRITT 2: POST /events –', JSON.stringify(requestBody, null, 2));
      const result = await ApiService.post('/events', requestBody);
      console.log('✅ Backend Response:', result);

      const eventData = result.event || result;
      console.log('📦 Event-Daten:', eventData);
      return eventData;
    } catch (error) {
      console.error('❌ Fehler beim Erstellen des Events:', error);
      throw error;
    }
  }

  // Hole alle Events
  async getEvents() {
    try {
      const result = await ApiService.get('/events');
      return result.events || result || [];
    } catch (error) {
      console.error('Fehler beim Laden der Events:', error);
      throw error;
    }
  }

  // Hole einen Event per ID
  async getPost(postId) {
    try {
      const event = await ApiService.get(`/events/${postId}`);
      return event;
    } catch (error) {
      console.error('Fehler beim Laden des Events:', error);
      throw error;
    }
  }

  // Setze Event-Status auf "bereit"
  async markAsReady(eventId) {
    try {
      console.log(`🎯 Setze Event ${eventId} auf Status "bereit"`);
      const response = await ApiService.patch(`/events/${eventId}/status`, {
        status: 'bereit'
      });
      console.log('✅ Status erfolgreich geändert:', response.message);
      return response.event || response;
    } catch (error) {
      console.error('❌ Fehler beim Setzen des Status:', error);
      throw error;
    }
  }

  // Hole Liste der generierten Bilder eines Events
  async getGeneratedImages(postId) {
    try {
      const images = await ApiService.get(`/events/${postId}/images`);
      // Normalisiere auf Array von { page, url }
      if (Array.isArray(images)) {
        return images.map(item => {
          const page = typeof item === 'object' ? (item.page ?? item) : item;
          return {
            page,
            url: ApiService.getImageUrl(`/events/${postId}/images/${page}`)
          };
        });
      }
      return [];
    } catch (error) {
      console.error('Fehler beim Laden der generierten Bilder:', error);
      throw error;
    }
  }

  // Hole URL für ein hochgeladenes Bild eines Events
  getPostImageUrl(postId, filename) {
    return ApiService.getImageUrl(`/events/${postId}/uploads/${filename}`);
  }

  // Hole URL für ein generiertes Bild (nach Seitennummer)
  getGeneratedImageUrl(postId, page) {
    return ApiService.getImageUrl(`/events/${postId}/images/${page}`);
  }
}

export default new PostService();
